import {
  IExternalReview,
} from "apps/website/components/feature/Review/ExternalReview/ExternalReview";

const CAT_EATING_KATKIN_FRESH_IMAGE = "https://a.storyblok.com/f/176726/3072x1217/22a54f0df7/cat-eating-katkin-fresh-meat-duck.jpg/m/";
const TRUSTPILOT_LOGO = "https://a.storyblok.com/f/176726/300x75/a75f713fc7/tp-logo-tricolor-black-rgb.svg";

export const data = {
  title: "Incredible Health Benefits",
  subtitle: "As reported by 95% of KatKin customers",
  finalText: "Plus, our cat parents say that feeding fresh soothes scores of other ailments.",
  finalText2: "But don’t just take our word for it.",
  image: {
    src: CAT_EATING_KATKIN_FRESH_IMAGE,
    alt: "Cat eating KatKin fresh meat (duck)",
    width: 3072,
    height: 1217,
  },
  imageTextListItems: [
    {
      body: "No grains your cat struggles to\n digest = no smell, no mess, no\n fuss.",
      image: {
        height: 520,
        src: "https://a.storyblok.com/f/176726/150x150/5ca3fa921e/kk-illos-landing-pages_less-mess.svg",
        width: 690,
      },
      title: "Better digestion,\nless stink in the litter box",
    },
    {
      body: "Meat is a cat’s best source of\nenergy. They’re tired\nand moody without it.",
      image: {
        height: 520,
        src: "https://a.storyblok.com/f/176726/150x150/1224de0b8b/kk-illos-landing-pages_restored-energy.svg",
        width: 690,
      },
      title: "More energy and playfulness",
    },
    {
      body: "Less shed, more shine thanks\nto good fats and nutrients\nHealthy inside and out.",
      image: {
        height: 520,
        src: "https://a.storyblok.com/f/176726/150x150/91e2486874/kk-illos-landing-pages_shinier-coat.svg",
        width: 690,
      },
      title: "Shinier, thicker coat\nand less hairballs",
    },
    {
      body: "Personalised calories get\ncats easily to their healthy\nweight. No fuss.",
      image: {
        height: 520,
        src: "https://a.storyblok.com/f/176726/150x150/31b5c3481e/kk-illos-landing-pages_healthier-weight.svg",
        width: 690,
      },
      title: "Easy-to-maintain\nhealthy weight.",
    },
  ],
  reviews: [
    {
      title: "Food allergies",
      body: "“Her fur grew back to the lovely coat she had before she had allergies, and overall she’s much happier and healthier.” Dexy + Pickle",
      stars: 5,
      hideStars: false,
      autor: "",
      authorLogo: {
        src: TRUSTPILOT_LOGO,
      },
    },
    {
      title: "IBD",
      body: "Tried drugs from the vet, literally 100s of other cat foods, now his stools are normal, at last!",
      stars: 5,
      hideStars: false,
      autor: "",
      authorLogo: {
        src: TRUSTPILOT_LOGO,
      },
    },
    {
      title: "Colitis",
      body: "She had colitis so I looked for a healthy option. This has cleared up and she’s now a happy healthy cat.",
      stars: 5,
      hideStars: false,
      autor: "",
      authorLogo: {
        src: TRUSTPILOT_LOGO,
      },

    },
    {
      title: "Appetite loss",
      body: "My elderly cat had very little appetite, but on KatKin she’s eating heartily and looking for more.",
      stars: 5,
      hideStars: false,
      autor: "",
      authorLogo: {
        src: TRUSTPILOT_LOGO,
      },
    },
    {
      title: "Sensitive stomach",
      body: "It's been two weeks now. Her stomach normalised. It gives me such a joy to see our cat transforming.",
      stars: 5,
      hideStars: false,
      autor: "",
      authorLogo: {
        src: TRUSTPILOT_LOGO,
      },
    },
    {
      author: "",
      body: "He had explosive diarrhoea several times a day, so I thought I'd try KatKin. The diarrhoea stopped instantly.",
      stars: 5,
      title: "Diarrhoea",
      hideStars: false,
      authorLogo: {
        src: TRUSTPILOT_LOGO,
      },
    },
  ] as IExternalReview[],
  reviewSectionFooter: "",
};
